import React, { Component, useState, useEffect } from "react";
import { Col, Card, CardBody } from "reactstrap";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import { LATEST_FAULT_LOG_COLUMN_DATA } from "../Utility/Constants";
import { connect } from "react-redux";
import { ChargerDiv } from "../Utility/styleComponents";
import { computeDate, computeTime } from "../Utility/utilsFunctions";
import { chargerSelected } from "../../store/actions";

const LatestFaultLog = (props) => {
  const [faultLog, setFaultLog] = useState([]);
  const { faultData, chargerSelected, dbFilter } = props;
  const { dateRange, location } = dbFilter;
  // to update the selected charger data
  const selectCharger = (chargerId) => {
    if (chargerId === null) return;
    chargerSelected(chargerId);
  };

  useEffect(() => {
    const startDate = new Date(dateRange[0]).getTime();
    const endDate = new Date(dateRange[1]).getTime();

    if (faultData?.length === 0) {
      return;
    }
    let chargersInSelectedLocation = [];
    if (location?.length > 0) {
      // chargersInSelectedLocation = props.chargerToLocationMap[location] || [];
      const chargersInSelectedLoc = props.chargerToLocationMap[location] || [];
      chargersInSelectedLocation = chargersInSelectedLoc?.map((item) => item?.id) || [];
    }
    console.log("chargersInSelectedLocation: ", chargersInSelectedLocation);

    // filter the transaction for the selected date range
    let filteredStatus = [];
    filteredStatus = faultData?.filter((status) => {
      const statusTime = new Date(status.timeStamp).getTime();
      if (location?.length === 0) {
        return statusTime >= startDate && statusTime <= endDate;
      }
      return statusTime >= startDate && statusTime <= endDate && chargersInSelectedLocation?.includes(status?.chargerId);
    });
    console.log("filteredStatus: ", filteredStatus);
    // filter the transaction for the selected date range
    // let filteredStatus = [];
    // filteredStatus = faultData.filter((status) => {
    //   const statusTime = new Date(status.timeStamp).getTime();
    //   return statusTime >= startDate && statusTime <= endDate;
    // });

    // //Sort by StartTime
    // filteredStatus.sort((a, b) => {
    //   if (a.timeStamp && b.timeStamp) {
    //     return -a.timeStamp.localeCompare(b.timeStamp);
    //   }
    //   return 0; // or handle as necessary if startTime is missing
    // });

    let i = 0;
    let fault_data = [];
    filteredStatus.forEach((item) => {
      fault_data.push({
        id: ++i,
        connId: item.connectorId,
        chargerId: (
          <ChargerDiv
            key={item.chargerId}
            onClick={() => {
              selectCharger(item.chargerId);
              props.history.push("/cms-charger-detail");
            }}
          >
            {item.chargerId}
          </ChargerDiv>
        ),
        timeStamp: computeDate(item.timeStamp) + " " + computeTime(item.timeStamp),
        details: item.details,
      });
    });
    // if (JSON.stringify(trans_data) === JSON.stringify(transData)) return;

    setFaultLog(fault_data);
  }, [faultData, dateRange, location]);

  let data = {
    columns: LATEST_FAULT_LOG_COLUMN_DATA,
    rows: faultLog,
  };

  const options = {
    hideSizePerPage: false,
    hidePageListOnlyOnePage: false,
    sizePerPageList: [
      {
        text: "5th",
        value: 5,
      },
      {
        text: "10th",
        value: 10,
      },
      {
        text: "All",
        value: faultLog.length,
      },
    ],
  };
  return (
    <React.Fragment>
      <Col>
        <Card>
          <CardBody style={{ overflowX: "auto" }}>
            <h4 className="card-title mb-4">Fault Log</h4>

            <BootstrapTable keyField="id" data={faultLog} columns={data.columns} pagination={paginationFactory(options)} />
          </CardBody>
        </Card>
      </Col>
    </React.Fragment>
  );
};
// const mapStateToProps = (state) => ({
//   dateRange: state?.dashboardFilter?.dateRange,
//   location: state?.dashboardFilter?.location,
// });
const mapStateToProps = (state) => ({
  chargerToLocationMap: state?.sharedData?.chargerToLocationMap,
});
const mapDispatchToProps = (dispatch) => ({
  chargerSelected: (payload) => dispatch(chargerSelected(payload)),
});
export default connect(mapStateToProps, mapDispatchToProps)(LatestFaultLog);
